import styled, { keyframes } from 'styled-components';
import { Box } from '@oneboard/ui-components';

export const StyleUsersModal = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  color: #d6dae0;
  border-radius: 16px;
  background: #fff;
  /* padding: 34px 16px 0; */
  gap: 20px;
`;

export const StyleHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  text-align: center;
  padding: 16px 12px 16px 24px;
  padding-bottom: 16px;
  color: #212b36;
  .close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    cursor: pointer;
  }
`;

export const StyledUserCell = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
`;

export const StyledModalHead = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  color: #8b90a0;
  > .title {
    flex: 1;
  }
`;

export const StyledModalBody = styled.div`
  margin-right: ${({ isScrollable }) => (isScrollable ? '-18px' : 0)};
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
  color: #212b36;
  width: 100%;
  overflow: scroll;
  height: 270px;
`;

export const StyledTeacher = styled.div`
  margin-bottom: 12px;
`;

export const StyledName = styled(Box)`
  font-size: 16px;
  width: 190px;
  color: ${({ active }) => (active ? '#EC7963' : '#637381')};
`;

export const StyledRewards = styled(Box)`
  /* flex: 1; */
  display: flex;
  align-items: center;
`;

const flash = keyframes`
  from {
    color: #D5D7DE;
  }

  to {
    color: #8B90A0;
  }
`;

export const StyledStage = styled(Box)`
  flex: 0.5;
  display: flex;
  align-items: center;
  color: ${({ isOnStaged }) => (isOnStaged ? '#EC7963' : '#D5D7DE')};
  cursor: pointer;

  &:hover {
    color: #8b90a0;
  }

  animation: ${({ isRaiseHand }) => (isRaiseHand ? flash : '')};
  animation-duration: 0.8s;
  animation-iteration-count: infinite;
`;

export const StyleLiteUsersModal = styled.div`
  display: flex;
  flex-direction: column;
  width: 230px;
  height: 100%;
  padding: 16px;
  background-color: #232323;
  color: #d6dae0;
`;
